"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const cuandoAplica = ["La operación de tu empresa creció más rápido que los procesos.", "Hay herramientas que compraste pero no se hablan entre ellas.", "El equipo invierte horas en tareas que tienen patrón claro.", "Estás evaluando si automatizar, qué automatizar, o si lo que tienes implementado vale la pena mantenerlo."];
export default function PreCalificacion() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="contacto-precalificacion" id="pre-calificacion" className="bg-background text-foreground py-24 md:py-32 overflow-hidden border-t border-border/30">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl">
        <div ref={headerRef} className={`mb-16 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal text-foreground leading-tight mb-6">
            Antes de agendar.
          </h2>
          <p className="font-sans text-lg text-muted-foreground leading-relaxed max-w-2xl mb-4">
            Una llamada con Fulcro es más útil cuando alguna de estas condiciones aplica.
          </p>
          <p className="font-sans text-lg text-muted-foreground leading-relaxed max-w-2xl">
            Esta llamada es para entender tu operación, no para cotizar a ciegas ni hacer demos. Si hay fit, seguimos.
          </p>
        </div>
        <BloqueCuandoAplica />
        <div className="mt-16 pt-10 border-t border-border/30">
          <p className="font-serif italic text-xl md:text-2xl text-foreground/90 leading-snug max-w-2xl">Si alguna de estas condiciones aplica, agenda con confianza.</p>
        </div>
      </div>
    </section>;
}
function BloqueCuandoAplica() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <div ref={ref} className={`max-w-2xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      <div className="font-mono text-xs tracking-widest text-primary uppercase mb-6">
        Cuándo aplica
      </div>
      <h3 className="font-serif text-2xl md:text-3xl text-foreground font-normal leading-tight mb-8">
        Cuando alguna de estas afirmaciones es cierta.
      </h3>
      <ul className="space-y-5">
        {cuandoAplica.map((item, i) => <li key={i} className="flex gap-4 font-sans text-base md:text-lg text-foreground/90 leading-relaxed">
            <span className="font-mono text-primary text-sm mt-1.5 shrink-0">
              ·
            </span>
            <span>{item}</span>
          </li>)}
      </ul>
    </div>;
}